import { createFileRoute } from '@tanstack/react-router'
import { MonetizationDashboard } from '@/features/monetization-dashboard/components/MonetizationDashboard'

export const Route = createFileRoute('/_auth/monetization-dashboard')({
  component: MonetizationDashboardPage,
})

function MonetizationDashboardPage() {
  return (
    <div className='container mx-auto py-6'>
      <MonetizationDashboard />
    </div>
  )
}
